import request from "@/utils/request";

// 楼栋类型判断
function getRoomTypeByBuildId(buildId) {
  const id = Number(buildId);
  if (id >= 1 && id <= 4) return '小房间';
  if (id >= 5 && id <= 6) return '大房间';
  return '其他';
}

export default {
  data() {
    return {
      activeTab: 'approve',
      isMobile: window.innerWidth <= 768,

      // 审批Tab
      searchApprove: '',
      filterApproveState: '',
      approveList: [],
      approveTotal: 0,
      approvePage: 1,
      loadingApprove: false,
      approveDialogVisible: false,
      approveAction: '',
      approverName: '',
      currentRow: null,

      // 分配Tab
      searchAssign: '',
      assignList: [],
      assignTotal: 0,
      assignPage: 1,
      loadingAssign: false,
      assignDialogVisible: false,
      assignForm: { dormBuildId: '', dormRoomId: '' },
      targetBuildings: [],
      availableRooms: [],
      loadingRooms: false,
      submitting: false,
    };
  },
  computed: {
    approveDialogTitle() {
      return this.approveAction === '已通过' ? '审批通过' : '审批拒绝';
    },
    isAssignVisible() {
      const identity = sessionStorage.getItem('identity') || '';
      return identity === 'dormManager' || identity === 'admin';
    },
  },
  created() {
    this.loadApproveList();
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 768;
    },

    reasonTypeTag(type) {
      const map = { '单独住宿': 'danger', '环境问题': 'warning', '房间设施问题': 'success' };
      return map[type] || 'info';
    },
    stateTag(state) {
      const map = { '未处理': 'info', '已通过': 'success', '已拒绝': 'danger', '已分配': 'success' };
      return map[state] || 'info';
    },
    formatRoomLabel(buildId, roomId) {
      if (buildId && roomId) return buildId + '栋-' + roomId + '号';
      return '未分配';
    },

    handleTabClick(tab) {
      if (tab.paneName === 'approve') this.loadApproveList();
      else this.loadAssignList();
    },

    // ========== 审批 ==========
    async loadApproveList() {
      this.loadingApprove = true;
      try {
        const params = { pageNum: this.approvePage, pageSize: 10 };
        if (this.searchApprove) params.search = this.searchApprove;
        if (this.filterApproveState) params.state = this.filterApproveState;

        const res = await request.get('/applyChangeRoom/find/all', { params });
        if (res.code == '0' || res.code === 0) {
          let list = (res.data.records || []).map(r => ({
            ...r,
            oldRoomDisplay: this.formatRoomLabel(r.oldDormBuildId, r.oldDormRoomId),
          }));
          // 前端过滤状态（如果后端不支持state参数）
          if (this.filterApproveState) {
            list = list.filter(r => r.state === this.filterApproveState);
          }
          this.approveList = list;
          this.approveTotal = this.filterApproveState ? list.length : (res.data.total || 0);
        }
      } catch (e) {
        console.error('加载审批列表失败', e);
      } finally {
        this.loadingApprove = false;
      }
    },

    openApproveDialog(row, action) {
      this.currentRow = row;
      this.approveAction = action;
      this.approverName = '';
      this.approveDialogVisible = true;
    },

    async submitApprove() {
      if (!this.approverName) {
        this.$message.warning('请输入审批人姓名');
        return;
      }
      try {
        const res = await request.post('/applyChangeRoom/approve', {
          id: this.currentRow.id,
          state: this.approveAction,
          approver: this.approverName,
        });
        if (res.code == '0' || res.code === 0) {
          this.$message.success(this.approveAction === '已通过' ? '审批通过' : '已拒绝');
          this.approveDialogVisible = false;
          this.loadApproveList();
        } else {
          this.$message.error(res.msg);
        }
      } catch (e) {
        this.$message.error('审批失败');
      }
    },

    // ========== 分配 ==========
    async loadAssignList() {
      this.loadingAssign = true;
      try {
        const params = { pageNum: this.assignPage, pageSize: 10 };
        if (this.searchAssign) params.search = this.searchAssign;

        const res = await request.get('/applyChangeRoom/find/all', { params });
        if (res.code == '0' || res.code === 0) {
          // 过滤出已通过和已分配的
          let list = (res.data.records || []).map(r => ({
            ...r,
            oldRoomDisplay: this.formatRoomLabel(r.oldDormBuildId, r.oldDormRoomId),
          })).filter(r => r.state === '已通过' || r.state === '已分配');
          if (this.searchAssign) {
            list = list.filter(r => r.name.includes(this.searchAssign) || (r.oldRoomDisplay || '').includes(this.searchAssign));
          }
          this.assignList = list;
          this.assignTotal = list.length;
        }
      } catch (e) {
        console.error('加载分配列表失败', e);
      } finally {
        this.loadingAssign = false;
      }
    },

    openAssignDialog(row) {
      this.currentRow = row;
      this.assignForm = { dormBuildId: '', dormRoomId: '' };
      this.availableRooms = [];
      this.initTargetBuildings(row);
      this.assignDialogVisible = true;
    },

    initTargetBuildings(row) {
      const targetType = row.targetRoomType;
      const buildings = [
        { id: 1, label: '1栋(小房间)', type: '小房间' },
        { id: 2, label: '2栋(小房间)', type: '小房间' },
        { id: 3, label: '3栋(小房间)', type: '小房间' },
        { id: 4, label: '4栋(小房间)', type: '小房间' },
        { id: 5, label: '5栋(大房间)', type: '大房间' },
        { id: 6, label: '6栋(大房间)', type: '大房间' },
      ];
      this.targetBuildings = buildings.filter(b => b.type === targetType);
      if (this.targetBuildings.length === 1) {
        this.assignForm.dormBuildId = this.targetBuildings[0].id;
        this.loadAvailableRooms();
      }
    },

    async loadAvailableRooms() {
      if (!this.assignForm.dormBuildId) return;
      this.loadingRooms = true;
      this.assignForm.dormRoomId = '';
      try {
        const buildId = Number(this.assignForm.dormBuildId);
        const res = await request.get('/room/find', {
          params: { dormBuildId: buildId, pageNum: 1, pageSize: 9999 }
        });
        if (res.code == '0' || res.code === 0) {
          const allRooms = res.data?.records || res.data || [];
          // 过滤未满房间（排除特殊房间如meeting/pingpong等maxCapacity=0的）
          this.availableRooms = allRooms
            .filter(r => {
              const cur = Number(r.currentCapacity) || 0;
              const max = Number(r.maxCapacity) || 0;
              return max > 0 && cur < max;
            })
            .map(r => ({
              dormRoomId: r.dormRoomId,
              roomLabel: r.dormRoomId + '号(已住' + (r.currentCapacity || 0) + '/' + r.maxCapacity + '人)',
            }));
        }
      } catch (e) {
        console.error('加载房间失败', e);
      } finally {
        this.loadingRooms = false;
      }
    },

    async submitAssign() {
      if (!this.assignForm.dormBuildId || !this.assignForm.dormRoomId) {
        this.$message.warning('请选择楼栋和房间');
        return;
      }
      this.submitting = true;
      try {
        const user = JSON.parse(sessionStorage.getItem('user') || '{}');
        const res = await request.post('/applyChangeRoom/assign', {
          id: this.currentRow.id,
          newDormBuildId: this.assignForm.dormBuildId,
          newDormRoomId: this.assignForm.dormRoomId,
          assigner: user.name || user.username || '',
        });
        if (res.code == '0' || res.code === 0) {
          this.$message.success('分配成功');
          this.assignDialogVisible = false;
          this.loadAssignList();
        } else {
          this.$message.error(res.msg);
        }
      } catch (e) {
        this.$message.error('分配失败');
      } finally {
        this.submitting = false;
      }
    },
  },
};
